export interface UsoConta {
  profile_id: string;
  username: string | null;
  role: string | null;
  status: string | null;
  nome: string;
}

export interface UsoPessoa {
  /** colaborador_id ou "conta:<profile_id>" quando a conta não foi agrupada */
  pessoa_key: string;
  nome: string;
  colaborador_id: string | null;
  contas: UsoConta[];
  ativa: boolean;
  ultimo_acesso: string | null;
  minutos_ativos: number;
  dias_ativos: number;
  total_acoes: number;
  /** chave "entidade:operacao" → total */
  acoes_por_tipo: Record<string, number>;
  /** chave "YYYY-MM-DD" */
  por_dia: Record<string, { minutos: number; acoes: number }>;
}

export interface RelatorioUso {
  inicio: string;
  fim: string;
  pessoas: UsoPessoa[];
  serie_diaria: { dia: string; pessoas_ativas: number; minutos: number; acoes: number }[];
  /** dow ISO: 1 = segunda … 7 = domingo */
  mapa_calor: { dow: number; hora: number; minutos: number }[];
  acoes_por_tipo: { entidade: string; operacao: string; total: number }[];
  rotas: { rota: string; minutos: number }[];
}

export interface LinhaTempoUso {
  minutos: { minuto: string; profile_id: string; rota: string | null; dispositivo: string | null }[];
  acoes: { created_at: string; profile_id: string; entidade: string; operacao: string; entidade_id: string | null }[];
}

export interface Colaborador {
  id: string;
  nome: string;
  profile_ids: string[];
}

const ENTIDADES: Record<string, string> = {
  cliente: 'Cliente',
  card: 'Card',
  contrato: 'Contrato',
  agendamento: 'Agendamento',
  proposta: 'Proposta',
  comentario: 'Comentário',
  documento: 'Documento',
  parcela: 'Parcela',
  ocorrencia: 'Ocorrência',
  lance: 'Lance',
};

const OPERACOES: Record<string, string> = {
  criar: 'criado',
  editar: 'editado',
  mover: 'movido',
  excluir: 'excluído',
};

export function rotuloAcao(entidade: string, operacao: string): string {
  const nome = ENTIDADES[entidade] ?? entidade;
  let verbo = OPERACOES[operacao] ?? operacao;
  // concordância: "Proposta criada", "Parcela editada", "Ocorrência criada"
  if (['proposta', 'parcela', 'ocorrencia'].includes(entidade)) verbo = verbo.replace(/o$/, 'a');
  return `${nome} ${verbo}`;
}

const ROTAS: Record<string, string> = {
  '/': 'Dashboard',
  '/vendas/pipeline': 'Pipeline',
  '/vendas/supervisao': 'Supervisão',
  '/agendamentos': 'Agendamentos',
  '/clientes': 'Clientes',
  '/clientes/novo': 'Novo cliente',
  '/clientes/:id': 'Perfil do cliente',
  '/clientes/:id/editar': 'Editar cliente',
  '/contratos': 'Contratos',
  '/propostas': 'Propostas',
  '/pos-venda': 'Pós-venda',
  '/grupos': 'Grupos',
  '/bens': 'Bens',
  '/comissoes': 'Comissões',
  '/meu-time': 'Equipe',
  '/superadmin': 'Superadmin',
  '/financeiro/fluxo-caixa': 'Fluxo de caixa',
  '/relatorios': 'Relatórios',
};

export function rotuloRota(rota: string): string {
  return ROTAS[rota] ?? rota;
}

export function formatarMinutos(minutos: number): string {
  if (minutos < 60) return `${minutos} min`;
  const h = Math.floor(minutos / 60);
  const m = minutos % 60;
  return m ? `${h}h ${m.toString().padStart(2, '0')}min` : `${h}h`;
}
